import {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import styled from "styled-components";
import ModalLayout from "../layouts/ModalLayout";
import {useWindowSize} from "../hooks/common/useWindowSize";
import {DText, FlexCenter, ScrollWrap} from "../styles/CommonStyles";
import WalletCard from "../packages/wallet-service/WalletCard";
import BankCard from "../packages/bank-service/BankCard";
import Text from "../utils/Text";
import getBankInfo from "../packages/bank-service/Bank";
import {HOME} from "../constants/urls";



const ChooseBankWalletModal = forwardRef((props, ref) => {

    const { width } = useWindowSize()
    const {
        label,
        options,
        onOptionChange,
        type,
        coin,
        wallet
    } = props

    const [verifiedOptions, setVerifiedOptions] = useState([])

    useEffect(() => {
        if (type === 'wallet') setVerifiedOptions(options)
        else setVerifiedOptions(options?.filter(item => item.verifyAt))
    }, [options])


    useImperativeHandle(ref, () => ({
        reset() {
            setSelected(-1)
        }
    }))

    const [modalOpen, setModalOpen] = useState(false)
    const [selected, setSelected] = useState(-1)
    const [bankInfo, setBankInfo] = useState(null)

    const onCardClicked = (idx, bankInfo) => {
        setSelected(idx)
        if (bankInfo) setBankInfo(bankInfo)

        setModalOpen(false)
        onOptionChange(idx)
    }

    const onPlaceHolderClicked = () => {
        const hasOption = verifiedOptions.filter(o => o.coin === coin)
        if (
            (hasOption?.length && type === 'wallet') ||
            (verifiedOptions?.length && type !== 'wallet')
        ) {
            setModalOpen(true)
        }else {
            window.location.href = HOME + "user/accounts-cards"
        }
    }

    return (
        <>

            <PlaceHolder onClick={onPlaceHolderClicked}>
                {selected === -1 ?
                    <Text tid={label} />
                    :
                    type === 'wallet' ?
                        verifiedOptions[selected].address
                        :
                        verifiedOptions[selected].shebaNo
                }
            </PlaceHolder>
            <ModalLayout
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                width={width < 768 ? '90%' : '768px'}
            >
                <FlexCenter style={{ marginBottom: '10px' }}>
                    <DText>
                        <Text tid={label} />
                    </DText>
                </FlexCenter>
                <ScrollWrap maxHeight='400px'>
                    <Grid type={type}>
                        {verifiedOptions?.map((option, idx) => (
                            <>
                                {type === 'wallet' ?
                                    <WalletOption
                                        item={option}
                                        idx={idx}
                                        onCardClicked={onCardClicked}
                                        coin={coin}
                                    />
                                    :
                                    <BankOption
                                        item={option}
                                        idx={idx}
                                        onCardClicked={onCardClicked}
                                    />
                                }
                            </>
                        ))}
                    </Grid>
                </ScrollWrap>
            </ModalLayout>
        </>
    )
})


const BankOption = ({
    item,
    idx,
    onCardClicked
}) => {

    const bankInfo = getBankInfo(item.cardNo)

    if (!bankInfo) {
        return <></>
    }

    return (
        <FlexCenter>
            <BankCard
                onClick={() => onCardClicked(idx, bankInfo)}
                bankInfo={bankInfo}
                bankAccount={item}
            />
        </FlexCenter>

    )
}


const WalletOption = ({
    item,
    idx,
    onCardClicked,
    coin
}) => {


    if (item.coin !== coin) {
        return null
    }

    return (
        <FlexCenter>
            <WalletCard
                onClick={() => onCardClicked(idx)}
                item={item}
            />
        </FlexCenter>
    )
}



const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 50%);
  row-gap: 40px;
  margin: 10px 0;
  
  @media screen and (max-width: 480px) {
    grid-template-columns: repeat(1, 100%);
  };
`


const PlaceHolder = styled.div`
  border: 1px solid ${props => props.theme.color};
  color: ${props => props.theme.color};
  border-radius: 8px;
  background-color: ${props => props.theme.tInputBg};
  min-height: 40px;
  width: 100%;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  padding: 0 10px;
  cursor: pointer;
`





export default ChooseBankWalletModal
